import { useRef, useState } from 'react';
import { Images } from 'assets/images';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { settingsActions } from 'store';
import { ROUTES } from 'utils/routeNames';
import {
  SettingsCategoryDeleteAccount,
  SettingsCategoryPassword,
  SettingsCategoryProfile,
  ACTIVE_CLASS,
  MAXIMUM_KB_USER_PUT,
} from 'utils/constant';
import {
  SettingsCategories,
  ImageContainer,
  UpdateAndDelete,
  UserImageWithUpdateAndDelete,
  RemoveAndUpdateButtons,
  UpdateImageButton,
  IconImg,
  UserImage,
  UserName,
  UserEmail,
  CategoriesSection,
  CategoryTextField,
  ImageSizeValidation,
} from './styled';

export const SettingsLeftSection = ({
  categoryName,
  currentUser,
  setCurrentUser,
  setIsRemoveAvatar,
  setIsChangedImage,
}) => {
  const navigate = useNavigate();
  const inputTypeFile = useRef('');
  const [hasSizeValidation, setHasSizeValidation] = useState(false);
  const dispatch = useDispatch();

  const handleUploadFile = (e) => {
    const { files } = e.target;
    const reader = new FileReader();

    if (files[0]?.size >= MAXIMUM_KB_USER_PUT) {
      setHasSizeValidation(true);
    } else {
      setHasSizeValidation(false);
      setIsRemoveAvatar(0);

      setIsChangedImage(true);

      reader.readAsDataURL(files[0]);

      const sendData = new FormData();

      sendData.append('image', files[0]);

      dispatch(settingsActions.updateAvatar(sendData));

      setCurrentUser((prevState) => ({
        ...prevState,
        profile_photo_path: URL.createObjectURL(files[0]),
      }));
    }
  };

  const removeUploadedFile = () => {
    setIsRemoveAvatar(1);
    setCurrentUser((prevState) => ({
      ...prevState,
      profile_photo_path: Images.defaultAvatar,
    }));
  };

  const clickOnFile = () => {
    inputTypeFile.current.click();
  };

  return (
    <SettingsCategories>
      <ImageContainer>
        <UserImageWithUpdateAndDelete>
          <UserImage
            src={
              currentUser.profile_photo_path
                ? currentUser.profile_photo_path
                : Images.defaultAvatar
            }
            categoryName={categoryName}
          />

          {SettingsCategoryProfile === categoryName ? (
            <RemoveAndUpdateButtons>
              <UpdateImageButton onClick={clickOnFile}>Upload</UpdateImageButton>
              <UpdateImageButton onClick={removeUploadedFile}>
                Remove
              </UpdateImageButton>
              <IconImg src={Images.redRecycleBin} onClick={removeUploadedFile} />
              <IconImg src={Images.addPhoto} onClick={clickOnFile} />
              <UpdateAndDelete
                type="file"
                ref={inputTypeFile}
                onChange={handleUploadFile}
                accept=".png, .jpg, .jpeg"
              />
            </RemoveAndUpdateButtons>
          ) : null}
        </UserImageWithUpdateAndDelete>

        {hasSizeValidation ? (
          <ImageSizeValidation> Maximum upload file size: 5Mb</ImageSizeValidation>
        ) : null}
      </ImageContainer>

      <UserName>{currentUser.name}</UserName>

      <UserEmail>{currentUser.email}</UserEmail>

      <CategoriesSection>
        <CategoryTextField
          onClick={() => navigate(ROUTES.SETTINGS)}
          className={SettingsCategoryProfile === categoryName ? ACTIVE_CLASS : null}
        >
          Profile Settings
        </CategoryTextField>

        <CategoryTextField
          onClick={() => navigate(ROUTES.CHANGE_PASSWORD)}
          className={SettingsCategoryPassword === categoryName ? ACTIVE_CLASS : null}
        >
          Password
        </CategoryTextField>
        {/* TODO email verification  */}
        {/* <CategoryTextField
          onClick={() => clickOnCategory(SettingsCategoryEmail)}
          className={SettingsCategoryEmail === categoryName ? 'active' : null}>
        Email Address
        </CategoryTextField> */}

        <CategoryTextField
          onClick={() => navigate(ROUTES.DELETE_ACCOUNT)}
          className={
            SettingsCategoryDeleteAccount === categoryName ? ACTIVE_CLASS : null
          }
        >
          Delete Account
        </CategoryTextField>
      </CategoriesSection>
    </SettingsCategories>
  );
};
